/**
 * Quanto custou uma mensagem, em micro-reais (1 real = 1.000.000).
 *
 * Inteiro, e não `number` com casas: R$ 0,035 somado dez mil vezes em ponto flutuante
 * não fecha com a fatura, e a soma do mês é a coluna que a atendente lê.
 *
 * O valor é uma ESTIMATIVA informativa (ADR 0030). Quem cobra é a Meta, pela linha de
 * crédito da Gupshup (ADR 0029), e a Zenda não repassa nada (ADR 0001).
 */
const GUPSHUP_USD_POR_MENSAGEM = 0.001;
const DOLAR_OUT_2026 = 5;
function micros(reais) {
    return Math.round(reais * 1_000_000);
}
/**
 * ✅ Meta, tabela em BRL do mercado Brasil vigente em 01/10/2026: marketing R$ 0,3217,
 * utilidade e serviço R$ 0,035 (pricing, "Cost per message in BRL").
 * ⚠️ Autenticação R$ 0,035: tabela BRL citada por parceiros, não conferida no PDF.
 * ⚠️ Gupshup US$ 0,001 por mensagem, de entrada e de saída (gupshup.ai, pricing).
 * Câmbio de referência de 13/10/2026, R$ 5,01 (Agência Brasil), arredondado.
 */
export const TABELAS_DE_PRECO = [
    {
        id: 'br-2026-10',
        vigenteDesde: '2026-10-01',
        moeda: 'BRL',
        meta: {
            marketing: micros(0.3217),
            marketing_lite: micros(0.3217),
            utility: micros(0.035),
            authentication: micros(0.035),
            authentication_international: micros(0.035),
            service: micros(0.035),
        },
        parceiro: { meta: 0, gupshup: micros(GUPSHUP_USD_POR_MENSAGEM * DOLAR_OUT_2026) },
        dolarEmReais: DOLAR_OUT_2026,
    },
];
export function tabelaVigente(quando, tabelas = TABELAS_DE_PRECO) {
    const ordenadas = [...tabelas].sort((a, b) => a.vigenteDesde.localeCompare(b.vigenteDesde));
    let escolhida = ordenadas[0];
    for (const t of ordenadas) {
        if (new Date(`${t.vigenteDesde}T00:00:00-03:00`) <= quando)
            escolhida = t;
    }
    return escolhida;
}
function normalizar(v) {
    if (v === undefined)
        return null;
    const s = v.trim().toLowerCase().replace(/-/g, '_');
    return /^[a-z_]{1,40}$/.test(s) ? s : null;
}
export function foiCobradaPelaMeta(c) {
    const tipo = normalizar(c.type);
    if (tipo !== null)
        return tipo === 'regular';
    return c.billable === true;
}
/**
 * `null` quando a mensagem não tem custo a registrar AGORA: o eco do celular e o
 * histórico não passaram pela API, e a saída ainda sem status não sabe se foi cobrada.
 */
export function custoDaMensagem(m, tabelas = TABELAS_DE_PRECO) {
    if (m.origem !== 'cloud_api' && m.origem !== 'inbound')
        return null;
    const tabela = tabelaVigente(m.quando, tabelas);
    const parceiroMicros = tabela.parceiro[m.provedor];
    if (m.direcao === 'in') {
        if (parceiroMicros === 0)
            return null;
        return { tabela: tabela.id, categoria: null, tipo: null, metaMicros: 0, parceiroMicros };
    }
    if (m.cobranca === null)
        return null;
    const categoria = normalizar(m.cobranca.category);
    const cobrada = foiCobradaPelaMeta(m.cobranca);
    const metaMicros = cobrada && categoria !== null ? (tabela.meta[categoria] ?? 0) : 0;
    return {
        tabela: tabela.id,
        categoria,
        tipo: normalizar(m.cobranca.type) ?? (cobrada ? 'regular' : null),
        metaMicros,
        parceiroMicros,
    };
}
//# sourceMappingURL=custo-de-mensagem.js.map